const monthlyMoney = (rule, value, callback) => {
    let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
    if (!reg.test(value)) {
        callback(new Error('请输入数字'));
    } else if (value <= 0) {
        callback(new Error('金额必须大于0'))
    } else {
        callback();
    }
};

function monthlyEndPower(rule, value, callback) {
    let index = rule.field.replace(/[^0-9]/ig, "");
    let start = this.params.monthlyInfoList[index].startPower;
    if (value <= start) {
        callback(new Error('结束瓦数小于开始瓦数'))
    } else {
        callback()
    }
}

export {
    monthlyMoney,
    monthlyEndPower
}